import React from 'react';
import { Badge } from './ui/badge';
import { ShieldCheck, ShieldAlert, ShieldX, ShieldQuestion } from 'lucide-react';

const STATUS_MAP = {
  valida: { label: 'Valida', cls: 'bg-emerald-100 text-emerald-700 border border-emerald-300', icon: ShieldCheck },
  in_scadenza: { label: 'In scadenza', cls: 'bg-amber-100 text-amber-800 border border-amber-300', icon: ShieldAlert },
  scaduta: { label: 'Scaduta', cls: 'bg-red-100 text-red-700 border border-red-300', icon: ShieldX },
  non_disponibile: { label: 'Non disponibile', cls: 'bg-slate-100 text-slate-600 border border-slate-300', icon: ShieldQuestion },
};

export default function CertificationStatusBadge({ status, days, className = '' }) {
  const v = STATUS_MAP[status] || STATUS_MAP.non_disponibile;
  const Icon = v.icon;
  let suffix = '';
  if (status === 'in_scadenza' && typeof days === 'number') suffix = ` · ${days}gg`;
  if (status === 'scaduta' && typeof days === 'number') suffix = ` · ${Math.abs(days)}gg fa`;
  return (
    <Badge className={`${v.cls} px-2.5 py-1 inline-flex items-center gap-1.5 ${className}`} data-testid={`cert-status-${status}`}>
      <Icon className="w-3.5 h-3.5" />
      <span>{v.label}{suffix}</span>
    </Badge>
  );
}

export const CERT_STATUSES = [
  { value: 'valida', label: 'Valida' },
  { value: 'in_scadenza', label: 'In scadenza' },
  { value: 'scaduta', label: 'Scaduta' },
  { value: 'non_disponibile', label: 'Non disponibile' },
];

export const CERT_TYPES = [
  'ISO 9001',
  'ISO 14001',
  'IATF 16949',
  'AS9100',
  'ISO 45001',
  'Altro',
];
